import React, { useState} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Web3 from './web3';




const root = ReactDOM.createRoot(document.querySelector('#root'));
root.render(
  <React.StrictMode>
    {/* <React.Suspense fallback={<Loader />}> */}


      <Web3  />

    {/* </React.Suspense>  */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
